<template>
  <div class="instruction-panel-entry">
    <h2 class="h2">{{ $t("instruction-panel.labellisation-mon-evaluation.title") }}</h2>

    <EvaluationPanel
      :projet-annuel="project"
      :evaluation="evaluation"
      :instruction-panel-width="instructionPanelWidth"
      :read-only="isEvaluationFinaleValidated"
      :is-evaluation-finale="false"
      :is-saving="isSaving"
      @save-evaluation="saveEvaluation"
      @evaluation-updated="handleEvaluationUpdated"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { EvaluationDTO, ProjetAnnuelDTO, ProjetInscriptionDTO } from "@/model/bean/GeneratedDTOs"
import EvaluationPanel from "@/pages/instruction/side-panel/commons/labellisation/EvaluationPanel.vue"
import { LoginService } from "@/services/rest/login/LoginService"

export default defineComponent({
  name: "InstructionPanelLabellisationMonEvaluation",
  components: {
    EvaluationPanel,
  },
  props: {
    project: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    instructionPanelWidth: {
      type: Number,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["save-evaluation"],
  data() {
    return {
      loginService: LoginService.INSTANCE,
      evaluation: new EvaluationDTO(),
      projetLabellisation: { ...this.project } as ProjetInscriptionDTO,
    }
  },
  computed: {
    isEvaluationFinaleValidated(): boolean {
      return this.projetLabellisation.evaluationFinaleValidated
    },
  },
  watch: {
    project: {
      handler(): void {
        this.updateEvaluation()
      },
      immediate: true,
    },
  },
  mounted(): void {
    this.updateEvaluation()
  },
  methods: {
    updateEvaluation(): void {
      const user = this.loginService.getLoggedUser()
      this.projetLabellisation = { ...this.project } as ProjetInscriptionDTO

      this.projetLabellisation.evaluations.forEach((item) => {
        if (user !== undefined && item.instructeur.id === user.id) {
          this.evaluation = item
        }
      })
    },

    saveEvaluation(evaluation: EvaluationDTO): void {
      this.$emit("save-evaluation", evaluation)
    },

    handleEvaluationUpdated(evaluation: EvaluationDTO): void {
      // Mettre à jour l'évaluation locale et la propager
      this.evaluation = evaluation
    },
  },
})
</script>
